import styled from "styled-components";
import { mediaMin } from "utils/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.reverseColors.primary};
  border-radius: ${(props) => props.theme.borderRadius.regular}px;
`;

export const InfoContainer = styled.div``;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;

  ${mediaMin("md")} {
    padding: 24px;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  padding-top: 8px;
`;
